var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":"缺陷等级分布","size":"small"}},[_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":"defect-grade"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }